import { useLearners } from './useLearners';
import { useLearnerStore } from '../stores/learnerStore';

// FP-LEARNER-STORE-RETIREMENT-01: returns the active learner (or the learner
// with the given id) derived from the ['learners'] React Query. Single
// source of truth with the list — no localStorage shadow that can return
// stale fields after a mutation.
//
// Falls back to the first active learner, then the first learner — covers
// the case where activeLearnerId is null on first run after signup or has
// been cleared because the previous one was deleted.
export function useLearner(id) {
  const activeLearnerId = useLearnerStore((s) => s.activeLearnerId);
  const targetId = id ?? activeLearnerId;
  const { data: learners = [], ...rest } = useLearners();

  const data =
    (targetId && learners.find((l) => l.id === targetId)) ||
    learners.find((l) => l.status === 'active') ||
    learners[0] ||
    null;

  return { ...rest, data };
}
